import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { Sparkles } from "lucide-react";

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.22V7.04H2.18a11 11 0 0 0 0 9.9l3.66-2.84z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.04l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
  </svg>
);

export const AuthModal = () => {
  const { authOpen, setAuthOpen, login } = useApp();

  return (
    <Dialog open={authOpen} onOpenChange={setAuthOpen}>
      <DialogContent className="sm:max-w-md bg-[#0d0d12] border border-[rgba(212,175,55,0.2)] text-white p-0 overflow-hidden" data-testid="auth-modal">
        <div className="relative p-8 grain">
          <DialogTitle className="sr-only">Sign in to MOVA</DialogTitle>
          <DialogDescription className="sr-only">Sign in with Google to save plans and bookings.</DialogDescription>
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 rounded-full border border-amber-400/40 flex items-center justify-center gold-glow">
              <Sparkles className="text-champagne" size={22} />
            </div>
          </div>
          <h3 className="font-serif text-3xl text-center text-champagne">Welcome to MOVA</h3>
          <p className="text-center text-slate-400 mt-3 text-sm leading-relaxed">
            Sign in to save plans, track bookings and unlock your personal concierge.
          </p>

          <button
            onClick={login}
            data-testid="google-login-btn"
            className="mt-8 w-full flex items-center justify-center gap-3 bg-white text-[#1a1a12] rounded-full py-3.5 font-medium hover:bg-slate-100 transition-colors duration-200"
          >
            <GoogleIcon /> Continue with Google
          </button>

          <p className="text-center text-[11px] text-slate-500 mt-6 leading-relaxed">
            By continuing you agree to MOVA's refined Terms of Service and Privacy Policy.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
